import { ReactComponent as CursorText } from 'approot/shared/icons/icon_cursor_text.svg';
import Icon, { IconProps } from './icon';

const IconCursorText = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={CursorText} />;
};

export default IconCursorText;
